import { AnyDocument, IncludeParams } from '../../../types';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const updateDocumentUserdata = async <
  DocumentType extends AnyDocument = AnyDocument,
  Payload = Record<string, unknown>,
>(
  constructPost: ConstructPost,
  documentParams: DocumentParams,
  documentId: DocumentType['id'],
  params: Partial<IncludeParams>,
  payload: Payload,
): Promise<NonPaginatedResponse<DocumentType> | undefined> =>
  constructPost<NonPaginatedResponse<DocumentType>>(
    `${DOCUMENTS_BASE_PATH}/${documentId}/userdata`,
    {
      params,
      headers: buildHeadersFromDocumentParams(documentParams),
      data: payload,
    },
  );
